import { render, staticRenderFns } from "./MediumList.vue?vue&type=template&id=39dfe520"
import script from "./MediumList.vue?vue&type=script&lang=js"
export * from "./MediumList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports